var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchieverFiler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 593,
    height: 463,
    viewBox: "0 0 593 463",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M279.229 85.7506L277.85 69.2794L308.787 71.4226L279.229 85.7506Z",
    fill: "url(#paint0_linear_1180_14)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5446 242.924L50.9174 268.363L29.625 247.061L43.5446 242.924Z",
    fill: "#EFAFAB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M308.658 32.9044L317.98 21.27L327.372 37.3472L308.658 32.9044Z",
    fill: "#EFAFAB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M227.992 27.1003L252.134 16.2086L234.053 40.2964L227.992 27.1003Z",
    fill: "url(#paint1_linear_1180_14)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.643 175.703L108.377 170.582L113.125 176.063L105.643 175.703Z",
    fill: "url(#paint2_linear_1180_14)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85938 163.98L9.84878 144.713L27.0161 154.803L6.85938 163.98Z",
    fill: "#87C6A8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M301.042 113.485L290.98 103.476L307.155 96.2253L301.042 113.485Z",
    fill: "url(#paint3_linear_1180_14)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M490.752 50.1725L514.894 39.2803L496.813 63.3681L490.752 50.1725Z",
    fill: "#87C6A8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5625 220.047L58.885 208.413L68.2766 224.49L49.5625 220.047Z",
    fill: "#F4C8C3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M574.803 46.9517L565.281 55.697H575.949L574.803 46.9517Z",
    fill: "#A5DBCA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6582 209.286L26.9801 197.652L36.3717 213.729L17.6582 209.286Z",
    fill: "#A5DBCA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9141 24.5149L46.8974 9.13431L56.9894 26.3001L34.9141 24.5149Z",
    fill: "#87C6A8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M155.906 59.5469L160.436 47.8171L176.4 61.7528L155.906 59.5469Z",
    fill: "url(#paint4_linear_1180_14)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M361.764 37.8833L378.46 27.8132L381.736 47.455L361.764 37.8833Z",
    fill: "#F4C8C3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M102.713 304.489L119.409 294.419L122.685 314.061L102.713 304.489Z",
    fill: "#F4C8C3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4297 114.798L48.4061 91.7091L48.136 121.827L35.4297 114.798Z",
    fill: "#EFAFAB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M208.318 125.918L210.39 111.154L226.676 120.179L208.318 125.918Z",
    fill: "#EFAFAB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M540.41 240.451L544.113 214.226L554.802 242.384L540.41 240.451Z",
    fill: "#EFAFAB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M242.908 45.6096L245.457 40.8361L249.882 45.9451L242.908 45.6096Z",
    fill: "url(#paint5_linear_1180_14)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M569.102 182.957L572.091 163.689L589.258 173.779L569.102 182.957Z",
    fill: "#A5DBCA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9356 445.698L6.87305 435.689L23.0473 428.438L16.9356 445.698Z",
    fill: "url(#paint6_linear_1180_14)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M138.621 165.856L158.348 156.957L146.98 184.055L138.621 165.856Z",
    fill: "#87C6A8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M82.178 404.747L77.1934 416.677L86.8808 412.209L82.178 404.747Z",
    fill: "#A5DBCA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M398.357 88.6103L412.101 65.9701L410.821 96.0619L398.357 88.6103Z",
    fill: "url(#paint7_linear_1180_14)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M407.953 27.3839L414.975 14.2327L427.165 28.3073L407.953 27.3839Z",
    fill: "#A5DBCA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M169.264 32.1462L181.549 17.0046L191.3 34.3665L169.264 32.1462Z",
    fill: "#87C6A8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4783 72.979L29.207 53.7575L48.6869 57.8868L32.4783 72.979Z",
    fill: "url(#paint8_linear_1180_14)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51172 386.108L20.208 376.037L23.4841 395.679L3.51172 386.108Z",
    fill: "url(#paint9_linear_1180_14)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9316 166.549L22.0871 158.928L28.9663 163.383L20.9316 166.549Z",
    fill: "#F4C8C3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M149.086 107.252L157.384 92.1881L168.35 106.823L149.086 107.252Z",
    fill: "#87C6A8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9375 49.8573L19.5153 32.8529L34.8648 42.7938L16.9375 49.8573Z",
    fill: "#F4C8C3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M146.693 66.2523L149.271 49.2479L164.621 59.1883L146.693 66.2523Z",
    fill: "#A5DBCA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5078 389.391L60.0856 372.386L75.4351 382.327L57.5078 389.391Z",
    fill: "#EFAFAB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M547.684 395.6L556.703 380.957L566.945 396.107L547.684 395.6Z",
    fill: "url(#paint10_linear_1180_14)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M497.217 17.0045L499.795 6.10352e-05L515.144 9.94098L497.217 17.0045Z",
    fill: "#A5DBCA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M299.064 165.351L315.761 155.281L319.037 174.922L299.064 165.351Z",
    fill: "#F4C8C3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M124.533 18.681L141.229 8.61093L144.506 28.2527L124.533 18.681Z",
    fill: "#F4C8C3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M571.209 29.8642L570.613 12.6759L587.53 19.6226L571.209 29.8642Z",
    fill: "#EFAFAB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M133.281 127.192L130.01 107.971L149.49 112.1L133.281 127.192Z",
    fill: "url(#paint11_linear_1180_14)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M568.496 33.2999L582.012 19.2468L590.267 37.3681L568.496 33.2999Z",
    fill: "url(#paint12_linear_1180_14)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M223.854 135.54L226.431 118.536L241.781 128.476L223.854 135.54Z",
    fill: "#F4C8C3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M477.254 264.307L470.07 264.277L473.244 257.328L477.254 264.307Z",
    fill: "#F4C8C3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2048 17.9521L66.5776 43.3904L45.2852 22.0884L59.2048 17.9521Z",
    fill: "#EFAFAB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M124.914 77.491L131.936 64.3394L144.126 78.4144L124.914 77.491Z",
    fill: "#EFAFAB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M467.105 125.553L475.868 121.6L469.305 130.343L467.105 125.553Z",
    fill: "#EFAFAB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M341.867 71.2666L345.498 66.7354L349.155 72.9966L341.867 71.2666Z",
    fill: "url(#paint13_linear_1180_14)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M582.072 70.9096L583.158 63.9158L589.389 67.5783L582.072 70.9096Z",
    fill: "#87C6A8"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M481.862 62.6938L477.943 58.796L484.243 55.9722L481.862 62.6938Z",
    fill: "url(#paint14_linear_1180_14)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M266.43 32.0883L272.882 50.4888L254.088 39.7387L266.43 32.0883Z",
    fill: "#87C6A8"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M471.486 103.271L478.509 90.1201L490.698 104.195L471.486 103.271Z",
    fill: "#F4C8C3"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M542.92 250.47L535.17 260.818L545.655 258.855L542.92 250.47Z",
    fill: "#A5DBCA"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M517.83 383.718L522.008 378.504L526.217 385.71L517.83 383.718Z",
    fill: "#A5DBCA"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5059 52.0838L52.6699 44.5797L59.3556 48.5097L51.5059 52.0838Z",
    fill: "#87C6A8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3203 96.9803L29.084 92.4121L35.3013 97.8394L27.3203 96.9803Z",
    fill: "url(#paint15_linear_1180_14)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M498.975 249.377L515.671 239.307L518.947 258.948L498.975 249.377Z",
    fill: "#87C6A8"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97461 299.077L21.6714 289.007L24.9476 308.648L4.97461 299.077Z",
    fill: "#F4C8C3"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M539.855 159.462L552.832 136.374L552.562 166.492L539.855 159.462Z",
    fill: "#F4C8C3"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M430.227 14.1577L447.752 12.3757L441.983 33.6065L430.227 14.1577Z",
    fill: "#EFAFAB"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M550.498 90.209L558.956 97.3411L546.619 94.8726L550.498 90.209Z",
    fill: "#EFAFAB"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M541.664 116L547.729 117.414L543.365 123.851L541.664 116Z",
    fill: "url(#paint16_linear_1180_14)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M188.678 95.9518L196.477 93.6039L195.771 101.892L188.678 95.9518Z",
    fill: "#87C6A8"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0762 382.372L28.5664 377.886L35.8154 374.636L33.0762 382.372Z",
    fill: "url(#paint17_linear_1180_14)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M370.541 70.2247L394.683 59.333L376.602 83.4208L370.541 70.2247Z",
    fill: "#87C6A8"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1766 456.531L39.9648 462.197L43.8637 459.43L41.1766 456.531Z",
    fill: "#A5DBCA"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M343.932 22.4067L353.334 18.1648L346.292 27.5457L343.932 22.4067Z",
    fill: "url(#paint18_linear_1180_14)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M354.631 53.4841L358.261 48.9528L361.919 55.2141L354.631 53.4841Z",
    fill: "#A5DBCA"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M232.49 107.462L233.575 100.468L239.807 104.13L232.49 107.462Z",
    fill: "#87C6A8"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4023 90.07L55.1289 82.5842L62.715 84.1925L56.4023 90.07Z",
    fill: "url(#paint19_linear_1180_14)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M195.229 186.689L196.232 180.066L202.21 183.938L195.229 186.689Z",
    fill: "#A5DBCA"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M393.922 18.2016L395.795 10.2635L402.788 14.2733L393.922 18.2016Z",
    fill: "#F4C8C3"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M529.215 200.316L530.37 192.695L537.249 197.15L529.215 200.316Z",
    fill: "#F4C8C3"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M585.51 424.041L586.586 416.938L592.998 421.091L585.51 424.041Z",
    fill: "#87C6A8"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M191.303 76.2341L184.119 76.203L187.293 69.2552L191.303 76.2341Z",
    fill: "#EFAFAB"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0781 78.4085L19.0819 71.7861L25.0596 75.6576L18.0781 78.4085Z",
    fill: "url(#paint20_linear_1180_14)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M461.746 111.792L468.618 109.697L467.64 117.273L461.746 111.792Z",
    fill: "#87C6A8"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M569.285 280.548L585.982 270.478L589.258 290.119L569.285 280.548Z",
    fill: "#87C6A8"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M124.342 160.064L130.844 156.142L132.12 163.791L124.342 160.064Z",
    fill: "#F4C8C3"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9453 68.0731L72.9491 61.4507L78.9268 65.3222L71.9453 68.0731Z",
    fill: "#F4C8C3"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8397 311.687L21.5684 292.465L41.0488 296.595L24.8397 311.687Z",
    fill: "url(#paint21_linear_1180_14)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M512.072 67.4948L518.575 63.5729L519.851 71.2222L512.072 67.4948Z",
    fill: "#A5DBCA"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M412.102 161.159L413.105 154.536L419.083 158.408L412.102 161.159Z",
    fill: "#A5DBCA"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M186.303 68.183L204.253 57.615L208.571 79.5478L186.303 68.183Z",
    fill: "#87C6A8"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8203 448.929L74.692 446.834L73.7144 454.41L67.8203 448.929Z",
    fill: "#F4C8C3"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M173.373 224.949L178.401 242.3L163.879 227.77L173.373 224.949Z",
    fill: "#EFAFAB"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M557.045 115.971L573.511 108.543L561.179 124.972L557.045 115.971Z",
    fill: "url(#paint22_linear_1180_14)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8574 315.922L91.9007 317.514L85.5484 328.51L81.8574 315.922Z",
    fill: "url(#paint23_linear_1180_14)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M0 338.067L2.03867 324.926L13.7476 331.808L0 338.067Z",
    fill: "#87C6A8"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6307 186.704L39.7676 179.878L50.7991 174.932L46.6307 186.704Z",
    fill: "url(#paint24_linear_1180_14)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M125.424 143.406L118.93 149.37H126.205L125.424 143.406Z",
    fill: "#A5DBCA"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M506.85 101.098L513.208 93.1624L519.613 104.128L506.85 101.098Z",
    fill: "#A5DBCA"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5332 244.046L19.9587 239.307L19.7813 252.887L7.5332 244.046Z",
    fill: "#87C6A8"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M465.184 149.851L473.664 148.572L470.801 162.738L465.184 149.851Z",
    fill: "url(#paint25_linear_1180_14)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M559.422 429.932L564.525 426.853L565.527 432.857L559.422 429.932Z",
    fill: "#F4C8C3"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M379.256 133.404L381.195 151.364L369.416 134.534L379.256 133.404Z",
    fill: "#EFAFAB"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M201.516 151.554L211.559 153.145L205.207 164.142L201.516 151.554Z",
    fill: "#EFAFAB"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8953 159.79L103.506 170.413L83.125 167.84L88.8953 159.79Z",
    fill: "#EFAFAB"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M108.248 337.782L117.344 333.238L118.571 345.878L108.248 337.782Z",
    fill: "#EFAFAB"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4434 309.121L36.4831 302.42L42.4533 305.929L35.4434 309.121Z",
    fill: "#A5DBCA"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M159.525 117.915L169.415 102.372L175.137 125.946L159.525 117.915Z",
    fill: "url(#paint26_linear_1180_14)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M311.268 117.581L329.247 119.34L310.371 127.445L311.268 117.581Z",
    fill: "#87C6A8"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6501 356.541L35.8984 357.619L41.8183 361.848L44.6501 356.541Z",
    fill: "#A5DBCA"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M496.731 75.7047L511.342 86.3279L490.961 83.7544L496.731 75.7047Z",
    fill: "url(#paint27_linear_1180_14)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M345.514 95.6153L351.872 87.6798L358.277 98.6455L345.514 95.6153Z",
    fill: "#A5DBCA"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M507.021 336.017L519.446 331.277L519.27 344.858L507.021 336.017Z",
    fill: "url(#paint28_linear_1180_14)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M329.165 66.8902L326.934 53.7803L340.22 56.5966L329.165 66.8902Z",
    fill: "url(#paint29_linear_1180_14)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9297 224.577L50.7365 221.074L51.8758 227.905L44.9297 224.577Z",
    fill: "url(#paint30_linear_1180_14)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2578 136.376L73.0162 124.779L83.485 131.559L71.2578 136.376Z",
    fill: "#87C6A8"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M435.455 144.38L446.401 140.161L445.698 152.615L435.455 144.38Z",
    fill: "#F4C8C3"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M573.602 207.438L584.547 203.22L583.844 215.672L573.602 207.438Z",
    fill: "url(#paint31_linear_1180_14)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5957 259.206L60.4923 253.292L65.8307 256.75L59.5957 259.206Z",
    fill: "#A5DBCA"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M460.717 209.136L452.176 210.376L458.677 201.708L460.717 209.136Z",
    fill: "#EFAFAB"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M511.076 17.0115L522.021 12.7927L521.319 25.2461L511.076 17.0115Z",
    fill: "url(#paint32_linear_1180_14)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M242.658 65.6507L243.555 59.7368L248.893 63.194L242.658 65.6507Z",
    fill: "#A5DBCA"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M380.721 216.622L392.108 209.753L394.343 223.149L380.721 216.622Z",
    fill: "#87C6A8"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M562.475 333.439L573.863 326.57L576.097 339.967L562.475 333.439Z",
    fill: "#F4C8C3"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4785 408.704L44.4238 404.485L43.7206 416.938L33.4785 408.704Z",
    fill: "#F4C8C3"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M354.977 134.554L365.259 126.121L369.395 139.057L354.977 134.554Z",
    fill: "url(#paint33_linear_1180_14)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M531.566 75.8875L543.174 82.3765L532.644 90.9545L531.566 75.8875Z",
    fill: "#87C6A8"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M555.939 365.325L557.698 353.728L568.167 360.508L555.939 365.325Z",
    fill: "#87C6A8"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1543 230.505L31.9611 227.003L33.1005 233.834L26.1543 230.505Z",
    fill: "url(#paint34_linear_1180_14)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M171.314 38.8592L177.121 35.3569L178.261 42.1884L171.314 38.8592Z",
    fill: "url(#paint35_linear_1180_14)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M209.93 39.7508L210.826 33.8363L216.165 37.2941L209.93 39.7508Z",
    fill: "#A5DBCA"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M447.568 116.101C447.568 116.101 453.106 103.786 445.155 95.0431C437.204 86.3006 425.882 85.4682 426.392 74.9405C426.392 74.9405 432.244 78.6882 437.592 82.2066C442.94 85.7255 458.962 100.362 447.568 116.101Z",
    fill: "#87C6A8"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M425.966 159.159C425.966 159.159 422.772 148.385 435.415 135.453C449.192 121.36 453.649 112.705 451.385 102.028C451.385 102.028 451.849 112.981 434.314 129.433C417.655 145.065 425.966 159.159 425.966 159.159Z",
    fill: "#87C6A8"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M426.119 40.0655C426.119 40.0655 424.831 51.5033 434.744 54.7349C444.657 57.9666 443.498 62.7068 443.498 62.7068C443.498 62.7068 446.277 63.0402 445.799 58.6558C445.321 54.2713 442.475 51.1201 435.317 48.7175C429.894 46.8965 430.492 42.6455 430.492 42.6455L426.119 40.0655Z",
    fill: "#87C6A8"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M443.96 54.4063C443.96 54.4063 446.504 59.5089 440.439 63.2695C434.373 67.0306 422.655 67.365 426.95 79.2064C426.95 79.2064 428.771 73.413 436.437 71.0785C444.103 68.744 448.86 61.4028 443.96 54.4063Z",
    fill: "#87C6A8"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4426 93.8832C87.4426 93.8832 82.713 81.1464 92.2809 73.6005C101.849 66.0552 114.251 66.6672 114.804 56.3104C114.804 56.3104 108.043 59.2371 101.856 62.0036C95.6696 64.77 76.7037 77.0615 87.4426 93.8832Z",
    fill: "#E2AF54"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M108.145 134.884C109.247 131.534 109.614 128.179 109.248 124.667C109.225 124.45 109.199 124.233 109.172 124.017C107.659 118.802 104.967 113.039 100.454 108.586C82.5075 90.8836 84.7665 79.6446 84.7665 79.6446C81.1822 89.7972 85.1186 98.8196 98.6234 114.333C111.016 128.568 106.409 138.698 106.409 138.698L106.801 138.402C107.303 137.244 107.755 136.071 108.145 134.884Z",
    fill: "url(#paint36_linear_1180_14)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1718 34.7795C91.1067 41.0027 96.1873 48.0228 104.28 51.27C112.373 54.5177 113.744 60.4102 113.744 60.4102C119.661 49.3749 106.95 47.5721 100.749 43.1314C98.4913 41.515 96.4767 37.1601 97.1075 35.8171C97.1075 35.8171 96.7372 35.0962 100.172 33.37C103.075 31.9118 107.181 33.3668 107.181 33.3668L108.623 29.3404C108.623 29.3404 106.657 29.0177 103.084 30.4294C99.5117 31.8415 97.1718 34.7795 97.1718 34.7795Z",
    fill: "url(#paint37_linear_1180_14)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M288.054 156.19C288.129 157.564 288.168 158.944 288.016 160.308C287.973 160.696 287.913 161.082 287.845 161.467C286.515 163.645 284.677 165.452 282.778 167.192C277.536 171.993 271.496 175.922 268.191 182.322C267.229 184.186 266.431 186.143 265.701 188.124C265.805 187.974 265.906 187.821 266.012 187.672C266.687 186.713 267.435 185.745 268.256 184.827C268.951 183.899 269.714 183.015 270.568 182.186C275.053 177.834 280.686 174.36 284.487 169.375C285.773 167.688 286.608 165.761 287.351 163.798C287.566 163.632 289.082 159.612 288.874 159.663C289.604 157.635 290.247 155.58 290.424 153.407C290.894 147.64 289.524 141.87 286.383 136.857C283.269 131.888 278.953 127.715 274.339 124.028C269.911 120.488 264.468 117.11 262.24 111.721C261.87 110.826 261.62 109.875 261.521 108.918C263.37 106.859 265.787 105.664 268.261 104.415C270.851 103.108 273.584 101.414 275.834 99.6243C278.036 97.8729 279.215 95.584 280.186 93.0356C280.211 92.9718 280.236 92.9075 280.26 92.8438C280.38 92.9767 281.478 90.0543 281.635 89.2375C282.395 87.1415 283.04 85.0031 283.26 82.786C283.564 79.7387 282.779 76.7831 281.159 74.1061C279.486 71.3413 277.192 68.9875 274.05 67.8502C272.323 67.2254 270.478 66.8122 268.674 66.4965C267.07 66.2157 265.257 65.6063 263.714 66.2092C263.242 66.3936 262.68 68.9125 262.501 69.3964C262.223 70.1505 261.946 70.905 261.677 71.6628C261.627 71.8038 261.458 72.5685 261.355 72.6087C262.733 72.0712 263.965 72.5434 265.389 72.747C267.019 72.9807 268.653 73.3435 270.241 73.7905C273.361 74.6688 275.694 76.2772 277.639 78.8089C279.301 80.974 280.528 83.51 280.885 86.172C281.055 87.4443 280.982 88.7203 280.806 89.9782C280.781 90.1539 280.752 90.3276 280.721 90.5007C279.105 92.9643 276.523 94.4146 274.034 95.9436C272.817 96.6912 271.649 97.5149 270.356 98.1419C268.944 98.8274 267.574 99.4721 266.307 100.396C264.182 101.945 262.599 103.813 261.642 106.236C261.595 106.353 261.546 106.473 261.498 106.592C261.236 106.359 259.972 109.814 259.751 110.971C259.332 112.262 259.056 113.575 259.129 114.867C259.444 120.499 264.799 125.009 269.128 128.231C273.871 131.762 278.417 135.663 281.991 140.335C285.674 145.15 287.734 150.273 288.054 156.19Z",
    fill: "#EFAFAB"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M261.498 106.591C261.547 106.472 261.596 106.353 261.642 106.236C262.599 103.812 264.181 101.945 266.307 100.395C267.574 99.4716 268.944 98.8264 270.356 98.1415C271.65 97.5144 272.817 96.6907 274.034 95.9431C276.522 94.4141 279.105 92.9633 280.721 90.5002L281.635 89.2386C281.478 90.0554 280.38 92.9778 280.26 92.8449C280.236 92.9087 280.211 92.973 280.186 93.0368C279.215 95.5851 278.035 97.8741 275.834 99.6255C273.584 101.415 270.85 103.11 268.261 104.416C265.787 105.665 263.37 106.859 261.521 108.92L261.498 106.591Z",
    fill: "#EFAFAB"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M287.353 163.798C286.61 165.761 285.775 167.687 284.488 169.375C280.687 174.361 275.055 177.834 270.57 182.186C269.716 183.014 268.953 183.899 268.257 184.827C267.437 185.745 266.689 186.712 266.013 187.672C265.908 187.821 265.807 187.973 265.703 188.124C266.433 186.143 267.231 184.185 268.193 182.322C271.498 175.922 277.537 171.994 282.779 167.192C284.679 165.452 286.517 163.644 287.847 161.467L287.353 163.798Z",
    fill: "#EFAFAB"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M562.056 324.487C560.954 324.497 560.006 324.633 558.9 324.459C557.674 324.265 556.414 324.174 555.265 323.665C553.408 322.843 551.981 321.178 551.009 319.436C549.167 316.134 548.656 312.3 548.264 308.598C548.26 308.561 548.256 308.523 548.252 308.486C549.852 305.896 550.985 302.949 551.359 300.129C551.91 295.973 552.079 291.434 551.522 287.266C550.868 282.368 548.834 277.42 544.861 274.29C543.445 273.174 541.816 272.528 540.09 272.202C539.02 273.774 537.975 275.362 536.945 276.961C538.846 276.999 540.824 277.188 542.533 277.971C546.378 279.731 548.973 283.801 550.255 287.693C550.918 289.708 551.29 291.814 551.452 293.927C551.494 294.479 551.519 295.031 551.533 295.584C551.535 295.645 551.534 295.707 551.535 295.768C551.336 296.667 550.649 298.911 550.563 299.138C549.853 300.998 548.908 302.934 547.716 304.692C547.3 302.729 546.57 300.854 545.055 299.522C541.989 296.826 536.431 296.815 533.942 300.242C532.843 301.756 532.706 303.479 532.635 305.253C532.579 305.964 532.53 306.781 532.56 307.15C532.511 308.895 532.631 310.451 533.526 312.084C534.581 314.009 536.247 315.297 538.468 315.521C540.901 315.766 543.025 314.444 544.737 312.842C545.722 311.921 546.64 310.846 547.464 309.677C547.911 311.729 548.007 313.861 548.28 315.935C548.693 319.077 549.434 322.361 551.155 325.065C552.133 326.602 553.517 328.038 555.233 328.728C557.345 329.577 559.608 329.474 561.808 329.454C561.942 329.453 561.996 324.489 562.056 324.487ZM542.455 309.749C538.576 311.875 534.591 309.599 533.233 305.941C533.306 305.809 533.38 305.679 533.461 305.553C533.972 304.75 534.661 304.034 535.465 303.521C537.004 302.54 538.91 302.418 540.67 302.713C543.204 303.137 545.163 304.399 546.343 306.505C545.219 307.814 543.926 308.943 542.455 309.749Z",
    fill: "#EFAFAB"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M551.542 287.3C550.888 282.403 548.853 277.454 544.881 274.324C543.465 273.209 541.835 272.563 540.109 272.237C539.039 273.808 537.994 275.396 536.964 276.996C538.866 277.034 540.843 277.223 542.552 278.005C546.397 279.765 548.993 283.836 550.274 287.727C550.938 289.743 551.241 291.081 551.403 293.194C551.445 293.745 551.555 295.802 551.555 295.802C551.897 294.31 551.542 287.3 551.542 287.3ZM533.252 305.974C533.252 305.974 533.591 305.418 534.061 304.802C534.532 304.185 534.557 304.28 535.682 303.434C536.808 302.589 539.059 302.273 542.13 303.098C545.225 303.931 546.361 306.538 546.361 306.538C546.361 306.538 546.745 306.057 547.134 304.776C547.523 303.494 547.038 302.403 546.512 301.33C545.987 300.257 545.074 299.556 545.074 299.556C542.007 296.86 536.449 296.848 533.961 300.275C532.883 301.76 532.828 303.752 532.826 303.788C532.773 304.862 533.252 305.974 533.252 305.974Z",
    fill: "#EFAFAB"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9128 340.192C56.9128 340.192 50.92 330.222 57.7799 322.357C64.6398 314.492 75.1745 313.043 74.003 304.24C74.003 304.24 68.7755 307.773 64.0063 311.081C59.2371 314.389 45.2172 327.736 56.9128 340.192Z",
    fill: "#E2AF54"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9573 374.904C79.9573 374.904 82.2339 365.648 69.5555 355.631C55.7392 344.715 51.0006 337.745 52.4127 328.634C52.4127 328.634 52.7011 337.858 70.1873 350.506C86.8011 362.522 79.9573 374.904 79.9573 374.904Z",
    fill: "url(#paint38_linear_1180_14)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9528 274.948C71.9528 274.948 73.9122 284.464 64.8539 287.834C55.7957 291.204 57.1923 295.105 57.1923 295.105C57.1923 295.105 54.6145 295.569 54.7726 291.857C54.9302 288.146 57.3847 285.312 63.9204 282.821C68.8729 280.933 68.0325 277.404 68.0325 277.404L71.9528 274.948Z",
    fill: "#E2AF54"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2161 288.168C56.2161 288.168 54.1732 292.619 60.0946 295.374C66.0155 298.13 76.9978 297.634 73.7618 307.858C73.7618 307.858 71.6771 303.116 64.3531 301.664C57.028 300.213 52.0948 294.366 56.2161 288.168Z",
    fill: "url(#paint39_linear_1180_14)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M502.456 197.523C502.367 198.797 502.305 200.081 502.391 201.377C502.415 201.746 502.452 202.115 502.497 202.484C503.475 204.701 504.855 206.641 506.285 208.526C510.23 213.729 514.812 218.224 517.221 224.657C517.923 226.53 518.495 228.468 519.014 230.419C518.937 230.264 518.862 230.108 518.784 229.954C518.284 228.965 517.727 227.959 517.114 226.989C516.596 226.027 516.027 225.096 515.385 224.205C512.015 219.526 507.738 215.512 504.912 210.333C503.956 208.58 503.354 206.666 502.825 204.73C502.663 204.545 501.582 200.582 501.742 200.657C501.224 198.661 500.773 196.653 500.686 194.599C500.455 189.144 501.648 183.938 504.194 179.68C506.717 175.461 510.152 172.149 513.806 169.331C517.313 166.626 521.601 164.211 523.449 159.478C523.756 158.693 523.971 157.837 524.07 156.957C522.687 154.78 520.844 153.333 518.959 151.829C516.986 150.254 514.91 148.299 513.21 146.318C511.547 144.382 510.688 142.081 509.995 139.567C509.977 139.504 509.96 139.44 509.942 139.377C509.846 139.485 509.065 136.604 508.962 135.819C508.422 133.756 507.972 131.67 507.852 129.567C507.688 126.678 508.362 124.022 509.678 121.74C511.036 119.384 512.865 117.497 515.321 116.862C516.672 116.513 518.109 116.379 519.512 116.33C520.759 116.286 522.175 115.964 523.356 116.737C523.717 116.974 524.094 119.405 524.221 119.882C524.418 120.625 524.616 121.367 524.806 122.112C524.841 122.251 524.954 122.988 525.033 123.04C523.98 122.35 523.015 122.623 521.909 122.619C520.643 122.615 519.37 122.732 518.132 122.933C515.698 123.328 513.856 124.514 512.294 126.615C510.958 128.412 509.95 130.615 509.613 133.054C509.452 134.219 509.479 135.422 509.586 136.622C509.602 136.79 509.62 136.956 509.641 137.122C510.834 139.645 512.798 141.353 514.689 143.121C515.612 143.986 516.497 144.915 517.483 145.678C518.561 146.511 519.606 147.3 520.564 148.336C522.173 150.075 523.354 152.036 524.039 154.431C524.072 154.548 524.107 154.666 524.142 154.784C524.35 154.602 525.248 158.004 525.392 159.115C525.687 160.379 525.87 161.644 525.784 162.841C525.41 168.062 521.164 171.548 517.742 173.969C513.991 176.623 510.384 179.649 507.511 183.528C504.551 187.528 502.84 192.036 502.456 197.523Z",
    fill: "url(#paint40_linear_1180_14)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M524.144 154.785C524.11 154.667 524.075 154.548 524.042 154.432C523.357 152.036 522.175 150.075 520.567 148.337C519.608 147.301 518.563 146.511 517.486 145.678C516.5 144.915 515.615 143.986 514.691 143.122C512.801 141.353 510.837 139.645 509.643 137.123L508.965 135.819C509.067 136.603 509.85 139.484 509.946 139.377C509.963 139.44 509.981 139.503 509.998 139.566C510.691 142.081 511.551 144.381 513.214 146.318C514.914 148.298 516.989 150.254 518.963 151.828C520.847 153.333 522.69 154.779 524.073 156.956L524.144 154.785Z",
    fill: "#E2AF54"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M502.828 204.73C503.357 206.666 503.959 208.58 504.915 210.333C507.741 215.512 512.019 219.526 515.389 224.205C516.03 225.096 516.6 226.026 517.117 226.989C517.73 227.958 518.287 228.965 518.787 229.954C518.866 230.108 518.941 230.264 519.017 230.419C518.499 228.468 517.926 226.53 517.225 224.657C514.815 218.224 510.233 213.729 506.288 208.526C504.859 206.641 503.479 204.701 502.5 202.484L502.828 204.73Z",
    fill: "#E2AF54"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M105.853 277.153C108.74 273.036 109.976 267.549 110.429 262.277C111.008 255.536 109.047 248.751 107.873 242.072C107.302 238.821 106.993 235.682 107.982 232.624C108.07 232.352 108.168 232.083 108.269 231.816C108.91 232.762 109.607 233.675 110.362 234.554C111.163 235.488 112.113 236.415 113.211 236.849C114.033 237.175 114.85 237.072 115.647 236.848C115.707 236.897 116.452 236.655 117.877 236.125C118.949 235.815 120.114 235.503 120.913 234.686C121.867 233.712 122.098 232.252 121.976 230.807C121.841 229.219 121.358 227.927 120.137 226.935C118.836 225.877 117.262 225.307 115.711 225.229C114.112 225.149 112.611 225.769 111.13 226.243C110.774 226.357 110.424 226.468 110.079 226.586C108.066 222.249 106.786 217.301 105.984 212.663C105.557 210.194 105.745 207.74 106.221 205.371C106.62 203.392 107.075 201.493 108.374 200.083C108.838 202.356 109.758 204.533 111.334 206.189C113.385 208.343 116.584 209.683 119.244 209.151C119.209 209.166 119.179 209.184 119.143 209.199C119.254 209.164 119.366 209.129 119.477 209.093C119.567 209.071 119.658 209.053 119.747 209.026C121.155 208.603 123.045 208.342 124.221 207.348C125.403 206.35 125.586 204.641 125.183 203.049C124.81 201.572 124.432 199.652 123.328 198.571C122.286 197.552 120.79 197.316 119.516 197.004C116.959 196.379 114.6 196.85 112.254 197.553C111.984 195.569 112.031 193.55 112.29 191.618C112.466 190.306 112.771 189.037 113.118 187.783C113.447 186.595 113.724 185.35 114.547 184.482C114.197 184.85 112.975 184.953 112.493 185.106C111.96 185.275 110.86 185.35 110.455 185.777C109.413 186.876 109.104 188.689 108.727 190.203C108.266 192.059 107.998 193.977 107.986 195.941C107.979 196.912 108.039 197.913 108.177 198.911C106.353 199.625 104.608 200.611 103.497 202.378C102.692 203.66 102.381 205.354 102.085 206.888C101.717 208.793 101.521 210.78 101.724 212.77C101.92 214.692 102.475 216.584 102.91 218.468C103.407 220.624 104.05 222.734 104.778 224.824C105.269 226.233 105.847 227.576 106.512 228.86C104.609 231.054 103.354 234.468 103.209 237.522C103.014 241.603 104.301 245.918 105.071 249.946C105.934 254.461 106.727 259.041 106.338 263.57C105.993 267.591 105.177 271.877 103.538 275.404C102.222 278.235 100.317 280.566 97.9688 282.295C100.791 280.975 103.393 279.166 105.853 277.153ZM116.811 198.657C117.714 198.91 118.65 199.236 119.351 199.991C120.181 200.885 120.48 202.195 120.809 203.357C121.287 205.041 121.436 206.702 120.721 207.897C119.204 207.55 117.652 206.703 116.485 205.828C114.453 204.306 113.182 201.834 112.576 199.292C112.474 198.864 112.39 198.432 112.32 197.998C113.814 197.956 115.29 198.232 116.811 198.657ZM110.83 228.118C110.753 227.97 110.68 227.82 110.604 227.671C110.985 227.263 111.393 226.909 111.827 226.554C112.001 226.562 112.175 226.574 112.352 226.6C113.002 226.698 113.644 226.878 114.264 227.15C115.475 227.682 116.806 228.573 117.405 229.928C117.962 231.187 118.082 232.899 117.775 234.184C117.661 234.662 117.471 235.107 117.211 235.496C116.268 235.103 115.413 234.333 114.677 233.515C113.249 231.926 111.843 230.047 110.83 228.118Z",
    fill: "#A5DBCA"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M112.317 197.998C112.317 197.998 112.672 197.994 113.234 198.01C113.796 198.027 113.792 198.039 114.072 198.085C114.917 198.224 117.195 198.77 118.174 199.316C119.154 199.861 119.581 200.27 120.136 201.256C120.692 202.242 121.105 204.68 121.206 206.013C121.307 207.345 120.717 207.896 120.717 207.896C120.717 207.896 121.008 208.14 121.479 208.181C121.951 208.221 122.838 208.135 123.313 207.926C123.788 207.717 124.215 207.342 124.215 207.342C125.397 206.344 125.58 204.635 125.177 203.043C124.804 201.566 124.426 199.646 123.322 198.565C122.28 197.546 120.784 197.31 119.51 196.998C116.953 196.373 114.594 196.844 112.248 197.547L112.317 197.998ZM111.02 226.43C111.623 226.397 111.69 226.503 112.349 226.6C113.009 226.698 114.007 227.045 115.229 227.649C116.45 228.253 116.548 228.679 117.224 229.577C117.9 230.475 117.898 231.904 117.912 233.289C117.926 234.673 117.208 235.496 117.208 235.496C117.208 235.496 118.041 235.969 118.428 235.966C118.815 235.962 119.423 235.626 119.993 235.361C120.563 235.096 120.909 234.681 120.909 234.681C121.862 233.707 122.093 232.247 121.971 230.803C121.836 229.215 121.353 227.922 120.133 226.93C118.831 225.873 117.257 225.302 115.706 225.224C114.107 225.144 112.606 225.764 111.125 226.238C110.769 226.352 110.419 226.463 110.074 226.582C110.074 226.582 110.418 226.463 111.02 226.43Z",
    fill: "#A5DBCA"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8866 170.8C32.0447 170.908 33.0298 171.1 34.2083 171.066C35.5159 171.027 36.8499 171.072 38.1045 170.78C40.1324 170.308 41.7858 169.14 42.9664 167.871C45.2055 165.464 46.0951 162.52 46.8454 159.669C46.8529 159.641 46.8605 159.611 46.868 159.583C45.4226 157.417 44.5002 155.015 44.3646 152.781C44.1647 149.489 44.4032 145.934 45.3695 142.734C46.5051 138.973 49.0985 135.3 53.5628 133.222C55.1545 132.482 56.9268 132.127 58.772 132.031C59.7533 133.354 60.7077 134.689 61.6445 136.03C59.6412 135.886 57.5442 135.852 55.6754 136.306C51.47 137.327 48.3675 140.265 46.6643 143.182C45.7822 144.693 45.1985 146.302 44.8352 147.935C44.7403 148.361 44.6631 148.79 44.5978 149.219C44.5908 149.267 44.5854 149.315 44.5785 149.362C44.7055 150.082 45.2232 151.895 45.2934 152.08C45.869 153.596 46.6868 155.192 47.779 156.672C48.3959 155.179 49.3359 153.783 51.0503 152.884C54.5221 151.062 60.369 151.561 62.673 154.461C63.6913 155.743 63.6773 157.099 63.59 158.489C63.5835 159.049 63.5599 159.69 63.4951 159.975C63.3874 161.341 63.1183 162.544 62.0277 163.736C60.7426 165.141 58.8722 165.993 56.5168 165.964C53.9347 165.932 51.8221 164.707 50.1677 163.301C49.2159 162.492 48.3493 161.57 47.5882 160.583C46.9307 162.142 46.6343 163.796 46.1578 165.389C45.436 167.802 44.3566 170.295 42.2981 172.247C41.1287 173.355 39.5424 174.349 37.6741 174.73C35.3755 175.199 33.0046 174.912 30.6926 174.695C30.5516 174.682 30.9488 170.805 30.8866 170.8ZM52.85 161.098C56.7344 163.111 61.1343 161.7 62.8975 158.971C62.8338 158.861 62.7668 158.753 62.6939 158.647C62.2292 157.974 61.57 157.353 60.7715 156.879C59.2431 155.973 57.2489 155.704 55.371 155.772C52.6667 155.871 50.4914 156.676 49.0578 158.211C50.12 159.335 51.3767 160.334 52.85 161.098Z",
    fill: "url(#paint41_linear_1180_14)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3469 142.758C46.4825 138.998 49.0759 135.325 53.5401 133.247C55.1318 132.506 56.9042 132.152 58.7494 132.055C59.7306 133.379 60.6851 134.713 61.6219 136.055C59.6186 135.911 57.5215 135.877 55.6528 136.331C51.4473 137.352 48.3449 140.289 46.6417 143.207C45.7595 144.718 45.3179 145.734 44.9546 147.367C44.8597 147.794 44.5559 149.388 44.5559 149.388C44.3313 148.193 45.3469 142.758 45.3469 142.758ZM62.8749 158.995C62.8749 158.995 62.5694 158.531 62.1305 158.007C61.6916 157.483 61.6568 157.555 60.5506 156.793C59.4445 156.03 57.1057 155.578 53.8006 155.941C50.4693 156.307 49.0351 158.237 49.0351 158.237C49.0351 158.237 48.6761 157.827 48.384 156.792C48.0919 155.757 48.7013 154.95 49.3524 154.161C50.0036 153.372 51.0277 152.909 51.0277 152.909C54.4995 151.087 60.3464 151.587 62.6504 154.486C63.6483 155.743 63.5245 157.302 63.5223 157.33C63.4805 158.171 62.8749 158.995 62.8749 158.995Z",
    fill: "#E2AF54"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M568.377 137.485L577.11 156.957L552.387 148.536L568.377 137.485Z",
    fill: "#EFAFAB"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M403.133 98.6723L415.548 83.1776L428.055 104.59L403.133 98.6723Z",
    fill: "#F4C8C3"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6348 200.597L79.9235 190.09L62.4817 213.327L56.6348 200.597Z",
    fill: "#EFAFAB"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M59.252 191.945L68.2443 180.722L77.3036 196.23L59.252 191.945Z",
    fill: "url(#paint42_linear_1180_14)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M188.592 38.7722L191.475 20.1857L208.036 29.9192L188.592 38.7722Z",
    fill: "#F4C8C3"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6559 319.221L5.94922 309.566L21.5517 302.572L15.6559 319.221Z",
    fill: "url(#paint43_linear_1180_14)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M568.26 146.173L561.102 130.455L582.07 127.038L568.26 146.173Z",
    fill: "#87C6A8"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8603 103.551L14.959 123.589H41.7361L38.8603 103.551Z",
    fill: "#A5DBCA"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M567.762 288.751L585.952 285.036L573.609 301.48L567.762 288.751Z",
    fill: "url(#paint44_linear_1180_14)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M564.572 262.675L573.565 251.452L582.624 266.961L564.572 262.675Z",
    fill: "url(#paint45_linear_1180_14)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M557.1 190.379L568.783 169.297L579.404 187.143L557.1 190.379Z",
    fill: "#F4C8C3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1180_14",
    x1: 277.85,
    y1: 77.5151,
    x2: 308.787,
    y2: 77.5151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1180_14",
    x1: 227.992,
    y1: 28.2523,
    x2: 252.134,
    y2: 28.2523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1180_14",
    x1: 105.643,
    y1: 173.322,
    x2: 113.124,
    y2: 173.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#A89100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#BCA10F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#D9B824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#EEC933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4413,
    stopColor: "#FBD33C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5562,
    stopColor: "#FFD63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6447,
    stopColor: "#FAD23C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7437,
    stopColor: "#EDC832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8478,
    stopColor: "#D7B622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9547,
    stopColor: "#B89D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A89100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1180_14",
    x1: 290.98,
    y1: 104.855,
    x2: 307.154,
    y2: 104.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#A89100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#BCA10F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#D9B824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#EEC933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4413,
    stopColor: "#FBD33C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5562,
    stopColor: "#FFD63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6447,
    stopColor: "#FAD23C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7437,
    stopColor: "#EDC832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8478,
    stopColor: "#D7B622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9547,
    stopColor: "#B89D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A89100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1180_14",
    x1: 155.906,
    y1: 54.7849,
    x2: 176.399,
    y2: 54.7849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1180_14",
    x1: 242.908,
    y1: 43.3905,
    x2: 249.881,
    y2: 43.3905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#A89100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#BCA10F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#D9B824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#EEC933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4413,
    stopColor: "#FBD33C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5562,
    stopColor: "#FFD63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6447,
    stopColor: "#FAD23C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7437,
    stopColor: "#EDC832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8478,
    stopColor: "#D7B622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9547,
    stopColor: "#B89D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A89100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1180_14",
    x1: 6.87321,
    y1: 437.068,
    x2: 23.0473,
    y2: 437.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#A89100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#BCA10F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#D9B824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#EEC933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4413,
    stopColor: "#FBD33C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5562,
    stopColor: "#FFD63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6447,
    stopColor: "#FAD23C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7437,
    stopColor: "#EDC832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8478,
    stopColor: "#D7B622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9547,
    stopColor: "#B89D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A89100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1180_14",
    x1: 398.357,
    y1: 81.016,
    x2: 412.101,
    y2: 81.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1180_14",
    x1: 29.2071,
    y1: 63.3683,
    x2: 48.6871,
    y2: 63.3683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1180_14",
    x1: 3.51177,
    y1: 385.859,
    x2: 23.4843,
    y2: 385.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1180_14",
    x1: 547.683,
    y1: 388.531,
    x2: 566.945,
    y2: 388.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#A89100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#BCA10F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#D9B824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#EEC933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4413,
    stopColor: "#FBD33C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5562,
    stopColor: "#FFD63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6447,
    stopColor: "#FAD23C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7437,
    stopColor: "#EDC832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8478,
    stopColor: "#D7B622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9547,
    stopColor: "#B89D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A89100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1180_14",
    x1: 130.01,
    y1: 117.582,
    x2: 149.49,
    y2: 117.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1180_14",
    x1: 568.496,
    y1: 28.3074,
    x2: 590.267,
    y2: 28.3074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1180_14",
    x1: 341.867,
    y1: 69.866,
    x2: 349.155,
    y2: 69.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#A89100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#BCA10F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#D9B824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#EEC933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4413,
    stopColor: "#FBD33C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5562,
    stopColor: "#FFD63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6447,
    stopColor: "#FAD23C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7437,
    stopColor: "#EDC832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8478,
    stopColor: "#D7B622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9547,
    stopColor: "#B89D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A89100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1180_14",
    x1: 477.944,
    y1: 59.3328,
    x2: 484.243,
    y2: 59.3328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#A89100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#BCA10F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#D9B824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#EEC933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4413,
    stopColor: "#FBD33C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5562,
    stopColor: "#FFD63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6447,
    stopColor: "#FAD23C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7437,
    stopColor: "#EDC832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8478,
    stopColor: "#D7B622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9547,
    stopColor: "#B89D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A89100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1180_14",
    x1: 27.3201,
    y1: 95.1259,
    x2: 35.3012,
    y2: 95.1259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1180_14",
    x1: 541.664,
    y1: 119.925,
    x2: 547.729,
    y2: 119.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#A89100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#BCA10F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#D9B824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#EEC933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4413,
    stopColor: "#FBD33C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5562,
    stopColor: "#FFD63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6447,
    stopColor: "#FAD23C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7437,
    stopColor: "#EDC832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8478,
    stopColor: "#D7B622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9547,
    stopColor: "#B89D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A89100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1180_14",
    x1: 28.5666,
    y1: 378.504,
    x2: 35.8153,
    y2: 378.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#A89100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#BCA10F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#D9B824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#EEC933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4413,
    stopColor: "#FBD33C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5562,
    stopColor: "#FFD63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6447,
    stopColor: "#FAD23C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7437,
    stopColor: "#EDC832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8478,
    stopColor: "#D7B622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9547,
    stopColor: "#B89D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A89100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1180_14",
    x1: 343.932,
    y1: 22.8555,
    x2: 353.334,
    y2: 22.8555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1180_14",
    x1: 55.1287,
    y1: 86.3273,
    x2: 62.7151,
    y2: 86.3273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1180_14",
    x1: 18.078,
    y1: 75.0974,
    x2: 25.0598,
    y2: 75.0974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#A89100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#BCA10F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#D9B824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#EEC933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4413,
    stopColor: "#FBD33C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5562,
    stopColor: "#FFD63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6447,
    stopColor: "#FAD23C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7437,
    stopColor: "#EDC832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8478,
    stopColor: "#D7B622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9547,
    stopColor: "#B89D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A89100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1180_14",
    x1: 21.5686,
    y1: 302.076,
    x2: 41.0486,
    y2: 302.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1180_14",
    x1: 557.045,
    y1: 116.757,
    x2: 573.511,
    y2: 116.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1180_14",
    x1: 81.8575,
    y1: 322.216,
    x2: 91.9005,
    y2: 322.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#A89100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#BCA10F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#D9B824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#EEC933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4413,
    stopColor: "#FBD33C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5562,
    stopColor: "#FFD63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6447,
    stopColor: "#FAD23C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7437,
    stopColor: "#EDC832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8478,
    stopColor: "#D7B622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9547,
    stopColor: "#B89D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A89100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1180_14",
    x1: 39.7677,
    y1: 180.818,
    x2: 50.7992,
    y2: 180.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#A89100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#BCA10F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#D9B824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#EEC933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4413,
    stopColor: "#FBD33C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5562,
    stopColor: "#FFD63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6447,
    stopColor: "#FAD23C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7437,
    stopColor: "#EDC832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8478,
    stopColor: "#D7B622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9547,
    stopColor: "#B89D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A89100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1180_14",
    x1: 465.184,
    y1: 155.655,
    x2: 473.664,
    y2: 155.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1180_14",
    x1: 159.525,
    y1: 114.159,
    x2: 175.138,
    y2: 114.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#A89100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#BCA10F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#D9B824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#EEC933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4413,
    stopColor: "#FBD33C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5562,
    stopColor: "#FFD63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6447,
    stopColor: "#FAD23C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7437,
    stopColor: "#EDC832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8478,
    stopColor: "#D7B622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9547,
    stopColor: "#B89D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A89100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1180_14",
    x1: 490.961,
    y1: 81.0162,
    x2: 511.342,
    y2: 81.0162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1180_14",
    x1: 507.021,
    y1: 338.068,
    x2: 519.447,
    y2: 338.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1180_14",
    x1: 326.934,
    y1: 60.3353,
    x2: 340.22,
    y2: 60.3353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1180_14",
    x1: 44.9294,
    y1: 224.49,
    x2: 51.8757,
    y2: 224.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1180_14",
    x1: 573.602,
    y1: 209.446,
    x2: 584.547,
    y2: 209.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1180_14",
    x1: 511.076,
    y1: 19.0194,
    x2: 522.022,
    y2: 19.0194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#A89100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#BCA10F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#D9B824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#EEC933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4413,
    stopColor: "#FBD33C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5562,
    stopColor: "#FFD63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6447,
    stopColor: "#FAD23C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7437,
    stopColor: "#EDC832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8478,
    stopColor: "#D7B622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9547,
    stopColor: "#B89D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A89100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1180_14",
    x1: 354.977,
    y1: 132.589,
    x2: 369.395,
    y2: 132.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1180_14",
    x1: 26.1541,
    y1: 230.418,
    x2: 33.1003,
    y2: 230.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1180_14",
    x1: 171.315,
    y1: 38.7726,
    x2: 178.261,
    y2: 38.7726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#A89100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#BCA10F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#D9B824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#EEC933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4413,
    stopColor: "#FBD33C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5562,
    stopColor: "#FFD63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6447,
    stopColor: "#FAD23C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7437,
    stopColor: "#EDC832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8478,
    stopColor: "#D7B622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9547,
    stopColor: "#B89D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A89100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1180_14",
    x1: 83.511,
    y1: 109.172,
    x2: 109.384,
    y2: 109.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1180_14",
    x1: 94.5017,
    y1: 44.8595,
    x2: 115.276,
    y2: 44.8595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1180_14",
    x1: 52.1739,
    y1: 351.768,
    x2: 81.3538,
    y2: 351.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1180_14",
    x1: 54.7187,
    y1: 298.013,
    x2: 74.3459,
    y2: 298.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1180_14",
    x1: 500.659,
    y1: 173.323,
    x2: 525.806,
    y2: 173.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1180_14",
    x1: 30.662,
    y1: 153.507,
    x2: 63.6272,
    y2: 153.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1180_14",
    x1: 59.2517,
    y1: 188.476,
    x2: 77.3039,
    y2: 188.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#A89100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#BCA10F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#D9B824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#EEC933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4413,
    stopColor: "#FBD33C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5562,
    stopColor: "#FFD63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6447,
    stopColor: "#FAD23C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7437,
    stopColor: "#EDC832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8478,
    stopColor: "#D7B622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9547,
    stopColor: "#B89D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A89100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1180_14",
    x1: 5.94922,
    y1: 310.897,
    x2: 21.5515,
    y2: 310.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#A89100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#BCA10F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#D9B824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#EEC933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4413,
    stopColor: "#FBD33C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5562,
    stopColor: "#FFD63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6447,
    stopColor: "#FAD23C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7437,
    stopColor: "#EDC832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8478,
    stopColor: "#D7B622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9547,
    stopColor: "#B89D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A89100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1180_14",
    x1: 567.762,
    y1: 293.258,
    x2: 585.952,
    y2: 293.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1180_14",
    x1: 564.572,
    y1: 259.206,
    x2: 582.624,
    y2: 259.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    stopColor: "#A89100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#BCA10F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#D9B824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#EEC933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4413,
    stopColor: "#FBD33C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5562,
    stopColor: "#FFD63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6447,
    stopColor: "#FAD23C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7437,
    stopColor: "#EDC832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8478,
    stopColor: "#D7B622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9547,
    stopColor: "#B89D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A89100"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchieverFiler);
export default __webpack_public_path__ + "static/media/Achiever_Filer.1ebde2c35da55dc91fab3103b63bdea9.svg";
export { ForwardRef as ReactComponent };